module.exports = __webpack_public_path__ + "../resources/img/ic_re_wifi_on_p2.232118a9.svg";